export const COLUMN_ACCESSORS = {
  SERVICE: 'service',
  DISPLAY_NUMBER: 'displayNumber',
  PRIORITY: 'priority',
  TYPE: 'type',
  ADDRESS: 'address',
  MANIFEST_LOCATION: 'manifestLocation',
  POSTCODE: 'postcode',
  RAG: 'ragStatus',
  PARCELS: 'totalParcels',
  CAD: 'totalCadParcels',
  SMALLS: 'totalSmalls',
  LOADED: 'totalLoaded',
  STOP_TIME: 'stopTime',
  ETA: 'eta',
  OT: 'opportunityTime',
  EXCEPTION: 'exception',
  WINDOW: 'window',
  NC: 'nonCompatibles',
  WEIGHT: 'weight',
  CHUTE: 'chute',
  REQUESTS: 'requests',
  PARCEL_NUMBER: 'parcelNumber',
  KING: 'king',
  LOAD: 'loaded',
  CAD_SCANNED: 'cadScanned',
  REQUEST_REASON: 'requestReason',
  TYPE_OF_COLLECTION: 'collectionType',
  STOP_NUMBER: 'stopNumber',
  REQUEST_TYPE: 'requestType',
  SEQUENCE_NUMBER: 'sequenceNumber',
  HIGH_VALUE: 'highValue',
  SMALLS_TOTE_PARCEL: 'smallsToteParcel',
  PARCELS_INFO: 'parcelsInfo',
  PICKUP_KIND: 'pickupKind',
};
